<template>
  <div class="functional-block-copy" bis_skin_checked="1">
    <ChatWidget/>
    <ContactModal/>
  </div>
</template>

<style lang="scss">
@use '/assets/scss/layout/_functional.scss';

</style>
